export const glassStyles = {
  // Dynamic glass effect (0px to 12px blur on hover)
  dynamic: {
    initial: {
      backdropFilter: 'blur(0px) saturate(175%)',
      backgroundColor: 'rgba(0, 32, 15, 0.05)',
      borderColor: 'rgba(255, 255, 255, 0.5)',
      transition: 'all 0.3s ease-in-out'
    },
    hover: {
      backdropFilter: 'blur(12px) saturate(175%)',
      backgroundColor: 'rgba(0, 32, 15, 0.02)',
      borderColor: 'rgba(255, 255, 255, 0.5)',
      transition: 'all 0.3s ease-in-out'
    }
  },
  // Static glass effect (constant 5px blur)
  static: {
    backdropFilter: 'blur(5px) saturate(175%)',
    backgroundColor: 'rgba(0, 32, 15, 0.02)',
    borderColor: 'rgba(255, 255, 255, 0.5)'
  },
  // Button style glass effect (constant 12px blur)
  button: {
    backdropFilter: 'blur(5px) saturate(120%)',
    backgroundColor: 'rgba(0, 32, 15, 0.02)',
    borderColor: 'rgba(255, 255, 255, 0.5)',
    border: '1px solid rgba(255, 255, 255, 0.5)',
    transition: 'all 0.3s ease-in-out'
  },
  // Button hover effect
  buttonHover: {
    backdropFilter: 'blur(10px) saturate(175%)',
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
    borderColor: 'rgba(255, 255, 255, 0.7)',
    border: '1px solid rgba(255, 255, 255, 0.7)',
    transform: 'scale(1.05)',
    transition: 'all 0.3s ease-in-out'
  },
  // Footer style glass effect (constant 2px blur)
  footer: {
    backdropFilter: 'blur(1px) saturate(175%)',
    backgroundColor: 'rgba(0, 32, 15, 0.02)',
    border: '1px solid rgba(255, 255, 255, 0.2)',
    borderColor: 'rgba(255, 255, 255, 0.5)'
  }
};

// Common Tailwind classes for glass containers
export const glassClasses = {
  container: 'rounded-[2rem] border border-white/50',
  button: 'rounded-full border border-white/50 px-8 py-3 hover:bg-white/20 transition-all duration-300'
}; 